<template>
  <div class="right">
    <div style="height: auto">

      <!-- ✅ 列表视图 -->
      <div v-if="!showDetail" style="min-height: 521px; overflow: hidden">
        <Table border :columns="columns" :data="data">
          <template #action="{ row }">
            <Button type="primary" size="small" @click="showDetailView(row.id)">详情</Button>
          </template>
        </Table>
      </div>

      <!-- ✅ 分页 -->
      <div v-if="!showDetail">
        <page
          v-model="pageNum"
          :total="total"
          show-total
          show-sizer
          show-elevator
          class="pag"
          :current="pageNum"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 50, 100, 500]"
          @on-change="changeIndex"
          @on-page-size-change="changePageSize"
        />
      </div>

      <!-- ✅ 详情视图 -->
      <div v-if="showDetail">
        <workProgressDetail 
          :id="currentId" 
          @backList="backList"  
        />
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import workProgressDetail from "./workProgressDetail.vue";

export default {
  name: "insideRight",
  components: { workProgressDetail },
  data() {
    return {
      data: [],           // 列表数据
      total: 0,           // 数据总数
      pageNum: 1,         // 当前页码
      pageSize: 10,       // 每页数量
      showDetail: false,  // 是否显示详情
      currentId: null,    // 当前详情 ID
      columns: [
        { type: "index", width: 50, align: "center" },
        { title: "类别", key: "expertType", width: 120 },
        { title: "项目名称", key: "project_name", width: 320 },
        { title: "采购预算", key: "budget", width: 120 },
        { title: "采购方式", key: "proMethod", width: 150 },
        { title: "使用方式", key: "use_dept", width: 150 },
        { 
          title: "开始时间", 
          key: "begainTime", 
          width: 180,
          render: (h, { row }) => {
            const date = new Date(row.begainTime);
            const formattedDate = date.toLocaleDateString();
            return h('span', formattedDate);
          }
        },
        { title: "操作", slot: "action", width: 100, align: "center" }
      ],
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    // ✅ 加载数据
    async fetchData() {
      try {
        const response = await axios.get(`${window.osConfig.registerUrl}/custom/schedule/getMaster`, {
          params: {
            size: this.pageSize,
            pageNum: this.pageNum
          }
        });

        if (response.data.code === 0) {
          const content = JSON.parse(response.data.content);
          this.data = content.map(item => ({
            id: item.id,
            expertType: item.expertType,
            project_name: item.project_name,
            budget: item.budget,
            proMethod: item.proMethod,
            use_dept: item.use_dept,
            begainTime: item.begainTime
          }));
          this.total = content.length;
        }
      } catch (error) {
        console.error("数据加载失败:", error);
        this.$Message.error("获取数据异常，请联系管理员");
      }
    },

    // ✅ 显示详情页
    showDetailView(id) {
      this.currentId = id;         // 将 ID 保存
      this.showDetail = true;      // 显示详情页
    },

    // ✅ 返回列表页
    backList() {
      this.showDetail = false;     // 切回列表
      this.currentId = null;       // 清空 ID
      this.fetchData();            // 返回时刷新数据
    },

    // ✅ 切换页码
    changeIndex(value) {
      this.pageNum = value;
      this.fetchData();
    },

    // ✅ 切换每页大小
    changePageSize(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.fetchData();
    }
  }
};
</script>

<style lang="less" scoped>
.right {
  min-height: 687px;
  width: 926px;
  float: left;
  padding-bottom: 60px;
}
.pag {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/inside/workProgressRight.vue